import {ReactElement} from "react"

const ProfileIcon = (): ReactElement => {
	return (
    <svg width="37" height="29" viewBox="0 0 37 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.90525 16.831C2.47074 15.8564 -0.11138 11.7143 1.03623 8.7905C2.47074 5.13573 11.7948 0.75 18.2501 0.75C24.7054 0.75 34.0298 5.13573 35.4643 8.7905C36.6119 11.7143 34.0298 15.8564 32.5952 16.831V20.4858C31.6389 22.9223 27.431 27.7953 18.2501 27.7953C9.06928 27.7953 4.86152 22.9223 3.90525 20.4858V16.831Z"
        fill="url(#linear-gradient-047AFF-03243D)"
      />
      <path
        d="M3.90525 16.831C2.47074 15.8564 -0.11138 11.7143 1.03623 8.7905C2.47074 5.13573 11.7948 0.75 18.2501 0.75C24.7054 0.75 34.0297 5.13573 35.4643 8.7905C36.6119 11.7143 34.0297 15.8564 32.5952 16.831M3.90525 16.831H32.5952M3.90525 16.831V20.4858M32.5952 16.831V20.4858M3.90525 20.4858H32.5952M3.90525 20.4858C4.86152 22.9223 9.06928 27.7953 18.2501 27.7953C27.431 27.7953 31.6389 22.9223 32.5952 20.4858M18.2501 7.32859C17.772 7.32859 16.8156 7.03621 16.8156 5.86668C16.8156 4.69715 17.772 4.40477 18.2501 4.40477C18.7283 4.40477 19.6847 4.69715 19.6847 5.86668C19.6847 7.03621 18.7283 7.32859 18.2501 7.32859ZM18.2501 7.32859V13.1762M18.2501 13.1762C16.8156 13.1762 14.6639 12.2016 13.9466 11.7143M18.2501 13.1762C19.6847 13.1762 20.8323 12.8838 22.5537 11.7143M16.8156 9.52145H19.6847"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="linear-gradient-047AFF-03243D"
          x1="18.2502"
          y1="0.75"
          x2="18.2502"
          y2="27.7953"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.163462" stopColor="#047AFF"/>
          <stop offset="0.822115" stopColor="#03243D"/>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ProfileIcon
